import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import Marquee from 'react-fast-marquee'

export function PoweredBy({ title, images = [], isPartner = false }) {
  const logos = [
    '/images/partners/cogxwhite.webp',
    '/images/partners/edge.webp',
    '/images/partners/ukbaafooter.webp',
    '/images/partners/Imagify-Startup-Network.webp',
    '/images/partners/logo1_google.webp',
    '/images/partners/HKTLogo.png',

    '/images/partners/logo2_nvidia.webp',
    '/images/partners/EdenBase.png',
    '/images/partners/logo3_notionwhite.webp',
    '/images/partners/logo4_hubspotwhite.webp',
    '/images/partners/logo5_zendesk.webp',
    '/images/partners/logo6_mathworks.webp',
    '/images/partners/logo7_github_circle.webp',
    '/images/partners/logo8_brexwhite.webp',
    '/images/partners/logo9_asanawhite.webp',
    '/images/partners/logo10_vestd.webp',
    '/images/partners/logo11_1passwordwhite.webp',
    '/images/partners/logo12_chartmogulwhite.webp',
    '/images/partners/logo13_taylorwessing.webp',
    '/images/partners/TransformBase.png',
    '/images/partners/logo14_forecastr.webp',
    '/images/partners/logo15_customerwhite.webp',
    '/images/partners/logo16_mode8.webp',
    '/images/partners/logo17_markandclerk.webp',
    '/images/partners/logo18_lovesocialmedia.webp',
    '/images/partners/logo19_syrena.webp',
    '/images/partners/logo20_huckletreewhite.webp',
    '/images/partners/logo21_flightcontrol.webp',
    '/images/partners/logo22_aivenwhite.webp',
    '/images/partners/logo23_mmu.webp',
    '/images/partners/logo24_buckworths.webp',
    '/images/partners/logo25_ubiops.webp',
    '/images/partners/logo26_edgetechwhite.webp',
    '/images/partners/logo27_thinkwik.webp',
  ]
  if (isPartner)
    return (
      <div className="  w-full mx-auto px-6 lg:px-8 font-sans">
        <FadeInStagger faster>
          <FadeIn>
            <div className="flex-col max-sm:p-6 justify-start items-center md:items-start inline-flex">
              <Marquee className="flex gap-8">
                <div className="flex gap-8 justify-between items-center">
                  {[...images, ...logos].map((logo, indx) => (
                    <img
                      key={indx}
                      src={`${logo}`}
                      alt={`${indx}`}
                      height={150}
                      width={150}
                      className="w-auto xl:w-full h-11"
                      objectFit="contain"
                    />
                  ))}
                </div>
              </Marquee>
            </div>
          </FadeIn>
        </FadeInStagger>
      </div>
    )
  return (
    <div className="mt-16 max-w-7xl w-full mx-auto px-6 lg:px-8 font-sans">
      <FadeInStagger faster>
        <div className="p-8 lg:p-16 w-full bg-neutral-900 rounded-2xl bg-opacity-20 border border-neutral-700 backdrop-blur-xl flex-col justify-start items-center md:gap-8 inline-flex">
          <FadeIn>
            <div className="self-stretch text-center text-gray-200 text-xl font-normal leading-[30px]">
              {title || 'Powered by:'}
            </div>
          </FadeIn>
          <div className="self-stretch justify-between items-center flex flex-col sm:flex-row overflow-hidden">
            <FadeIn>
              <div className="flex-col max-sm:p-6 justify-start items-center md:items-start inline-flex">
                <Marquee className="flex gap-8">
                  <div className="flex gap-8 justify-between items-center">
                    {[...images, ...logos].map((logo, indx) => (
                      <img
                        key={indx}
                        src={`${logo}`}
                        alt={`${indx}`}
                        height={150}
                        width={150}
                        className="w-auto xl:w-full h-11"
                        objectFit="contain"
                      />
                    ))}
                  </div>
                </Marquee>
              </div>
            </FadeIn>
          </div>
        </div>
      </FadeInStagger>
    </div>
  )
}
